// Fim do convidado (item 60): a conta anônima de antes vê esta tela cheia em todo lugar, menos na partida em que já
// estava sentada (ela termina a partida). Guardar com Google vincula o Google à mesma conta: o apelido, o rosto e os
// pontos continuam; na volta, a folha do celular abre e o painel recebe convidado_migrado.
import { useState } from 'react';
import { conta } from '../comum/conta.ts';
import { medir } from '../comum/medicao.ts';
import { LogoGoogle } from './Entrada.tsx';
import { Marca } from '@truco6/ui/Marca';
import { Tela } from './comum.tsx';

const MIGRANDO = 'truco6:convidado-migrando';
export const marcarMigracao = () => { try { localStorage.setItem(MIGRANDO, String(Date.now())); } catch { /* sem armazenamento: o painel perde o evento */ } };
// Na volta do Google, já com a conta guardada: true uma vez só.
export function voltouDaMigracao(): boolean {
  try {
    if (!localStorage.getItem(MIGRANDO)) return false;
    localStorage.removeItem(MIGRANDO);
    return true;
  } catch { return false; }
}

export function GuardarConta() {
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);
  return (
    <Tela>
      <div className="guardar-conta-tela">
        <Marca altura={48} />
        <h1>Agora o Truco de 6 pede cadastro</h1>
        <p className="sub">Guarde sua conta com Google. Seu apelido, seu rosto e seus pontos continuam.</p>
        <button className="google" disabled={ocupado} onClick={() => {
          setErro(null); setOcupado(true);
          medir('guardar_conta', { origem: 'fim_do_convidado' });
          marcarMigracao();
          conta.guardarComGoogle(location.href).catch((e: Error) => { setErro(e.message); setOcupado(false); });
        }}><LogoGoogle />{ocupado ? 'Um instante...' : 'GUARDAR COM GOOGLE'}</button>
        {erro && <p className="erro" role="alert">{erro}</p>}
        <p className="nota">Cadastro rápido. Você joga 2 partidas grátis por dia e ganha +5 a cada amigo que chamar.</p>
        <p className="nota links-legais">Ao guardar, você aceita os <a href="/termos">Termos de uso</a> e a <a href="/privacidade">Política de privacidade</a>.</p>
      </div>
    </Tela>
  );
}
